export default "__VITE_ASSET__aad2ff90__"